// extracted by css-extract-rspack-plugin
export default {"link":"_b5421a88","icon":"_bc4dda63","placeholder":"_d41fcd2b"};